import React, {Component, Fragment} from 'react';
import ReactTable from 'react-table';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import EditTable from './EditTable.js';

class BuildingModal extends Component {
	render() {
		let buildingColumns = [
			{
				Header:   'Delete',
				accessor: ''
			},
			{
				Header:   'ID',
				accessor: 'bldg_id'
			},
			{
				Header:   'PropNum',
				accessor: 'prop_num'
			},
			{
				Header:   'Building Name',
				accessor: 'bldg_name'
			},
			{
				Header:   'Display Name',
				accessor: 'display_name'
			},
			{
				Header:   'DNum',
				accessor: 'd_num'
			}
		];

		let buildingLength = this.props.buildingList.length;
		if (buildingLength && buildingLength > 0) {
			let footer = (
				<Fragment>
					<Button color="success" onClick={(e) => {
						return this.props.newBuildingRecord(e);
					}}>
						New Building
					</Button>
					<Button color="info" onClick={() => {
						this.props.toggleBuildingModal();
						this.props.writeData();
					}}>
						Save All Changes
					</Button>
					<Button color="warning" onClick={this.props.toggleBuildingModal}>
					  Close
					</Button>
				</Fragment>
			);

			if (this.props.showBatch) {
				footer = (this.props.batch);
			}

			return (
				<div>
					<Modal
						isOpen={this.props.buildingModalShow}
						toggle={this.props.toggleBuildingModal}
						size="lg"
					>
						<ModalHeader className="h2">Building List</ModalHeader>
						<ModalBody>
							<EditTable
								id="building-edit-table"
								deleteSingleRecord={(e, rec) => {
									this.props.toggleBuildingModal();
									this.props.deleteSingleRecord(e, rec);
								}}
								defaultPageSize={buildingLength}
								data={this.props.buildingList}
								columns={buildingColumns}
								triggerFormBoolChange={this.props.triggerFormBoolChange}
								triggerFormValueChange={this.props.triggerFormValueChange}
								triggerFormDateChange={this.props.triggerFormDateChange}
								parentTable="building"
							/>
						</ModalBody>
						<ModalFooter className="bldgListFooter">
							{footer}
						</ModalFooter>
					</Modal>
				</div>
			);
		}

		return '';

	}
}

export default BuildingModal;



// WEBPACK FOOTER //
// ./src/components/BuildingModal.js